(function () {
  if (!('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sel = '.rb-section .rb-head, .rb-fact, .rb-step, .rb-formula, .rb-offer__media, .rb-offer__copy, .rb-plan, .rb-faq__item, .rb-band, .rb-occ__card, .rb-cta__grid > *, .rb-prose';
  var els = document.querySelectorAll(sel);
  if (!els.length) return;
  var groups = {};
  els.forEach(function (el) {
    if (el.classList.contains('rb-reveal')) return;
    el.classList.add('rb-reveal');
    if (el.classList.contains('rb-formula--night')) el.classList.add('rb-reveal--l');
    if (el.classList.contains('rb-formula--day')) el.classList.add('rb-reveal--r');
    var p = el.parentElement; var key = p ? (p.dataset.rbg || (p.dataset.rbg = Math.random().toString(36).slice(2))) : 'x';
    groups[key] = groups[key] || []; el.dataset.rbi = groups[key].length; groups[key].push(el);
  });
  if (reduce) { els.forEach(function (el) { el.classList.add('rb-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target; var i = parseInt(el.dataset.rbi || '0', 10);
      el.style.transitionDelay = Math.min(i, 6) * 80 + 'ms';
      el.classList.add('rb-in'); io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  els.forEach(function (el) { io.observe(el); });
  // sticky add-to-cart nudge on product pages (desktop): reveal a slim bar after buy box scrolls out
  var form = document.querySelector('product-info .product-form, .product-form');
  var bar = document.querySelector('.rb-stickybar');
  if (form && bar) {
    var fio = new IntersectionObserver(function (en) { bar.classList.toggle('rb-stickybar--on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 });
    fio.observe(form);
  }
})();

// Hide the Shop Pay installments banner when the selected variant is below the $35 minimum (Reboot V3.1)
(function () {
  function check(el) {
    try {
      var meta = JSON.parse(el.getAttribute('shopify-meta') || '{}');
      var id = String(el.getAttribute('variant-id') || '');
      var v = (meta.variants || []).filter(function (x) { return String(x.id) === id; })[0];
      if (v && v.eligible === false) { el.setAttribute('data-rb-hidden', ''); } else { el.removeAttribute('data-rb-hidden'); }
    } catch (e) {}
  }
  function init() {
    document.querySelectorAll('shopify-payment-terms').forEach(function (el) {
      check(el);
      new MutationObserver(function () { check(el); }).observe(el, { attributes: true, attributeFilter: ['variant-id'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
